export default "__VITE_ASSET__BIU0o5an__"